
define(
	'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.Utility',
    [
        'Profile.Model'
    ],
    function (
        ProfileModel
    )
{
	'use strict';

	return  {

		showAsStandalone: function (layout, view) {
            layout.addToViewContextDefinition(view, 'isStandalone', 'boolean', function () {
                return true;
            });
        },

        hideSearch: function (layout, environment) {

            var config;
            var profile;
            var userRole;
            var allowedRoles;

            config = environment.getConfig('digiConfigSettings.digiMyAccountStandalone');
            allowedRoles = config && config.searchRoles && config.searchRoles.split(',');
            profile = ProfileModel.getInstance();
            userRole = profile && profile.get('userRole');

            layout.addToViewContextDefinition('Header.View', 'hideSearch', 'boolean', function () {
                return !allowedRoles || (allowedRoles && allowedRoles.indexOf(userRole + '') === -1);
            });

            layout.addToViewContextDefinition('Header.Menu.View', 'hideSearch', 'boolean', function () {
                return !allowedRoles || (allowedRoles && allowedRoles.indexOf(userRole + '') === -1);
            });
        }
	};
});
